var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overflow-hidden h-100" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentJob.state === "completed",
            expression: "currentJob.state === 'completed'",
          },
        ],
        staticClass: "h-100",
      },
      [
        _c(
          "div",
          { staticClass: "gallery-1 justify-content-center pb-20 h-100" },
          _vm._l(_vm.currentJob.base64_output_images, function (output) {
            return _c("div", { staticClass: "image h-100" }, [
              _c("img", { attrs: { src: output } }),
            ])
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }